import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

export const OpenMenuButton = styled.div`
  display: flex;
  align-items: center;
  color: ${Colors.Blue50};
  cursor: pointer;
`

export const CloseMenuButton = styled(OpenMenuButton)`
  color: ${Colors.Neutral30};
`
